<div class="board">
	@if (reconnecting$ | async) {
	<div class="board__status" role="status" aria-live="polite">
		{{ 'board.reconnecting' | translate }}
	</div>
	} @if (loading$ | async) {
	<div class="board__loading" aria-live="polite">
		{{ 'board.loading' | translate }}
	</div>
	} @else if (error$ | async) {
	<div class="board__error" role="alert" aria-live="assertive">
		{{ error$ | async }}
	</div>
	} @else {
	<header class="board__header">
		<div class="board__title-wrap">
			<h1 class="board__title">{{ 'board.title' | translate }}</h1>
			<span class="board__title-underline" aria-hidden="true"></span>
		</div>
	</header>

	<main class="board__sections">
		<section
			class="board__section board__section--prep"
			aria-labelledby="board-prep-title"
		>
			<h2 id="board-prep-title" class="board__section-title">
				{{ 'board.in_preparation_de' | translate }}
			</h2>
			<p class="board__section-subtitle">
				{{ 'board.in_preparation_en' | translate }}
			</p>
			<div class="board__grid" role="list">
				@for ( order of inPreparationOrders$ | async; track
				trackByOrderId($index, order) ) {
				<div
					class="board__tile board__tile--prep"
					role="listitem"
					[attr.aria-label]="getOrderAriaLabel(order)"
				>
					{{ getOrderNumber(order) }}
				</div>
				} @empty {
				<div class="board__empty" aria-live="polite">
					{{ 'board.empty_preparation' | translate }}
				</div>
				}
			</div>
		</section>

		<section
			class="board__section board__section--ready"
			aria-labelledby="board-ready-title"
		>
			<h2 id="board-ready-title" class="board__section-title">
				{{ 'board.ready_de' | translate }}
			</h2>
			<p class="board__section-subtitle">{{ 'board.ready_en' | translate }}</p>
			<div class="board__grid" role="list">
				@for ( order of readyOrders$ | async; track trackByOrderId($index,
				order) ) {
				<div
					class="board__tile board__tile--ready"
					role="listitem"
					[attr.aria-label]="getOrderAriaLabel(order)"
				>
					{{ getOrderNumber(order) }}
				</div>
				} @empty {
				<div class="board__empty" aria-live="polite">
					{{ 'board.empty_ready' | translate }}
				</div>
				}
			</div>
		</section>
	</main>
	}
</div>
